module.exports = __webpack_public_path__ + "img/gd-e-fes-x.a7dc8225.png";